export const ENV_CONFIG_VARIABLES = {
  REACT_APP_LOAD_DEFAULT_GAME_STATE: 'REACT_APP_LOAD_DEFAULT_GAME_STATE',
  REACT_APP_LOCAL_DEV_MODE: 'REACT_APP_LOCAL_DEV_MODE',
  REACT_APP_AUTO_LOAD_TEST_FIELD: 'REACT_APP_AUTO_LOAD_TEST_FIELD',
  REACT_APP_ADDITIONAL_COINS: 'REACT_APP_ADDITIONAL_COINS',
  REACT_APP_ADDITIONAL_ACTIONS: 'REACT_APP_ADDITIONAL_ACTIONS',
  REACT_APP_NO_SOUND_START_GAME: 'REACT_APP_NO_SOUND_START_GAME',
  REACT_APP_DISABLE_PHASE_BUTTON_COOLDOWN: 'REACT_APP_DISABLE_PHASE_BUTTON_COOLDOWN',
  REACT_APP_DISABLE_PHASE_CONFIRMATION_MODAL: 'REACT_APP_DISABLE_PHASE_CONFIRMATION_MODAL',
  REACT_APP_DISABLE_RANDOM_INITIATIVE: 'REACT_APP_DISABLE_RANDOM_INITIATIVE',
  REACT_APP_DISABLE_VERSION_MISMATCH: 'REACT_APP_DISABLE_VERSION_MISMATCH',
  REACT_APP_DISABLE_GAME_ANALYTICS: 'REACT_APP_DISABLE_GAME_ANALYTICS',
  REACT_APP_DISABLE_VK_PIXEL: 'REACT_APP_DISABLE_VK_PIXEL',
  REACT_APP_DISABLE_YANDEX_METRIKA: 'REACT_APP_DISABLE_YANDEX_METRIKA',
  REACT_APP_LOCAL_CHAT_ENABLED: 'REACT_APP_LOCAL_CHAT_ENABLED',
}